import { FieldErrors, UseFormRegister, UseFormWatch } from 'react-hook-form'
import type { FieldValues } from './RecipientsInformation'

const DelaySendingWelcomeMessage = ({
  errors,
  register,
  watch,
}: {
  errors: FieldErrors<FieldValues>
  register: UseFormRegister<FieldValues>
  watch: UseFormWatch<FieldValues>
}) => {
  return (
    <>
      <div>
        <fieldset className="form-item">
          <legend>
            <span>Delay sending welcome message?</span>
          </legend>
          <div>
            <div className="yes-or-no-radios" id="edit-delay-welcome-message">
              <div className="form-item js-form-type-radio">
                <input
                  className="form-radio"
                  id="edit-delay-welcome-message-1"
                  type="radio"
                  value="1"
                  {...register('delay_welcome_message')}
                />
                <label htmlFor="edit-delay-welcome-message-1">Yes</label>
              </div>
              <div className="form-item js-form-type-radio">
                <input
                  className="form-radio"
                  id="edit-delay-welcome-message-0"
                  type="radio"
                  value="0"
                  {...register('delay_welcome_message')}
                />
                <label htmlFor="edit-delay-welcome-message-0">No</label>
              </div>
            </div>
          </div>
        </fieldset>
      </div>
      {watch('delay_welcome_message') === '1' && (
        <div>
          <fieldset className="form-item">
            <legend>
              <span>Date the welcome message should be sent</span>
            </legend>
            <div>
              <div className="form-item">
                <div>
                  <input
                    className="form-text"
                    id="edit-delay-welcome-message-until"
                    type="date"
                    {...register('delay_until', {
                      required: 'Field is required',
                    })}
                  />
                  {errors.delay_until && (
                    <div className="form-item--error-message">
                      {errors.delay_until.message}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      )}
    </>
  )
}

export default DelaySendingWelcomeMessage
